import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "RecordLedger" }

import {basicFormConfig} from "@/views/main/report/ledger/recordLedger/config/form.config";
import {ref} from "vue";
import {useRoute} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'RecordLedger',
  setup(__props) {

const route = useRoute()
const defaultInfo = ref({})
defaultInfo.value = route.query
const modalSex = basicFormConfig.iForms[0].formItems.find((item) => item.field === 'sex')
const options = [{title: "男", value: '0'}, {title: "女", value: '1'}]
modalSex!.options = options

return (_ctx: any,_cache: any) => {
  const _component_BasicForm = _resolveComponent("BasicForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BasicForm, {
      basicFormConfig: _unref(basicFormConfig),
      pageName: "ledger",
      defaultInfo: defaultInfo.value
    }, null, 8, ["basicFormConfig", "defaultInfo"])
  ]))
}
}

})